<script>
  'use strict'
  
  import { _currentTheme } from "../store/store";
  import { themesCollection } from "../shared/theme.js";

  function switchTheme() {
    _currentTheme.set($_currentTheme + 1);

    if ($_currentTheme > themesCollection.length - 1) { 
      _currentTheme.set(0);
    }

    for (let key in themesCollection[$_currentTheme]) {
      if (key !== 'name') {
        const value = themesCollection[$_currentTheme][key]
        document.documentElement.style.setProperty(`--${key}`, `${value}`);
        
        // -- Set the popup alpha blur background color
        if (key === 'section-color') {
          document.documentElement.style.setProperty(`--section-color-alpha`, `${value}4d`);
        }
      }
    }
  }
</script>


<div tabindex="0" class="theme-palette" title="Change theme flavor" on:click="{switchTheme}">
  <span>🎨</span>
</div>


<style>
  .theme-palette {
    font-size: 1.4rem;
    width: 2.3rem;
    height: 2.3rem;
    border-radius: 50%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
  }

  .theme-palette:hover {
    cursor: pointer;
    background: var(--hightlight-color);
  }
</style>